import { createSlice } from '@reduxjs/toolkit'

export const idoData = createSlice({
    name: 'idoData',
    initialState: {
        allIDOs: [],
        filters: {
            name: '',
            showActiveIdos: false,
            saleType: '',
        }
    },
    reducers: {
        setIdoData: (state, data) => {
            const idoPayload = data.payload;
            state.allIDOs = idoPayload
        },
        setFilters: (state, data) => {
            state.filters = data.payload;
        },
    },
})

export const { setIdoData, setFilters } = idoData.actions

export default idoData.reducer
